/**
 * Forza l'uso di HTTPS in produzione
 * Redirect automatico da HTTP a HTTPS
 */

import { secureLog } from '@/utils/secureLogger';

export const enforceHttps = () => {
  // Solo in produzione (non in sviluppo locale)
  if (
    typeof window !== 'undefined' &&
    window.location.protocol === 'http:' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1' &&
    !window.location.hostname.includes('lovableproject.com') // Lovable sandbox già usa HTTPS
  ) {
    secureLog.info('Redirecting from HTTP to HTTPS');
    window.location.href = window.location.href.replace('http:', 'https:');
  }
};

/**
 * Verifica che le richieste API usino HTTPS
 */
export const validateHttpsUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    
    // Permetti HTTP solo in sviluppo locale
    if (urlObj.protocol === 'http:') {
      const hostname = urlObj.hostname;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return true;
      }
      
      secureLog.warn('Insecure HTTP API call attempted:', { url });
      return false;
    }
    
    return true;
  } catch (error) {
    secureLog.error('Invalid URL:', { url });
    return false;
  }
};
